import { decodeHtmlEntities } from '@opallabs/lambda'
import { setAssetReferenceData } from './assetReference'

export const setAccountData = (accountJson) => ({
  accountName: decodeHtmlEntities(accountJson.name),
  accountImage:
    accountJson.asset_reference &&
    setAssetReferenceData(accountJson.asset_reference),
  accountUsername: accountJson.username || accountJson.name,
  isAccountPremium: !!accountJson.is_premium,
})
